module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subject-dist text-dark"
  }, [(_vm.isPrintUsers) ? _c('SubjectDistributionPrint', {
    on: {
      "close": _vm.closeIsPrintUsers
    }
  }) : [_c('div', {
    staticClass: "subject-dist__header"
  }, [_c('div', {
    staticClass: "subject-dist__header__left"
  }, [_c('h1', [_vm._v(_vm._s(_vm.i18n[_vm.locale].subjects_for_teachers))]), _vm._v(" "), _c('ChangeSchoolYear', {
    attrs: {
      "whiteTheme": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "subject-dist__header__right"
  }, [(_vm.theZENToken.length > 0) ? _c('a', {
    attrs: {
      "href": _vm.zenUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].go_to_zen))]) : _vm._e(), _vm._v(" "), (_vm.userCanManageSchool) ? _c('button', {
    staticClass: "do-bttn bttn-export",
    on: {
      "click": function($event) {
        _vm.isOpenDurationModal = true
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale].export_to_zen) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flipper-buttons"
  }, [_c('button', {
    staticClass: "flipper-buttons__button",
    class: {
      'active': !_vm.isTasksView
    },
    on: {
      "click": function($event) {
        _vm.isTasksView = false
      }
    }
  }, [_c('span', {
    staticClass: "icon-year-planning"
  }), _vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale].subjects) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "flipper-buttons__button",
    class: {
      'active': _vm.isTasksView
    },
    on: {
      "click": function($event) {
        _vm.isTasksView = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-file-text"
  }), _vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale].tasks) + "\n          ")])])])]), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
    attrs: {
      "color": "blue"
    }
  }) : _c('div', {
    staticClass: "subject-dist__body"
  }, [_c('div', {
    staticClass: "doTable__users"
  }, [_c('div', {
    staticClass: "doTable__users__header"
  }, [_c('FilterUsers', {
    staticClass: "pad-10",
    attrs: {
      "searchText": _vm.i18n[_vm.locale].filter_users
    }
  })], 1), _vm._v(" "), (!_vm.isPoolsDeactivated) ? _c('div', {
    staticClass: "filter pointer"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isShowOnlyTeacherWithTeachingTime),
      expression: "isShowOnlyTeacherWithTeachingTime"
    }],
    attrs: {
      "type": "checkbox",
      "id": "only-teachers-with-teaching_time"
    },
    domProps: {
      "checked": Array.isArray(_vm.isShowOnlyTeacherWithTeachingTime) ? _vm._i(_vm.isShowOnlyTeacherWithTeachingTime, null) > -1 : (_vm.isShowOnlyTeacherWithTeachingTime)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isShowOnlyTeacherWithTeachingTime,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isShowOnlyTeacherWithTeachingTime = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isShowOnlyTeacherWithTeachingTime = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isShowOnlyTeacherWithTeachingTime = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "marg-5-left pointer no-select",
    attrs: {
      "for": "only-teachers-with-teaching_time"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale].only_show_users_with_uv_time) + "\n          ")])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "d-box users-list"
  }, [_c('li', {
    staticClass: "user-item user-item__header"
  }, [_c('div', {
    staticClass: "user-sorter",
    class: {
      'user-sorter--active': _vm.sortBy === 'name'
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('name')
      }
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].name) + "\n              "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-sorter",
    class: {
      'user-sorter--active': _vm.sortBy === 'teachingTimeDiff'
    },
    on: {
      "click": function($event) {
        return _vm.setSortBy('teachingTimeDiff')
      }
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].teaching_hours) + " "), _c('span', {
    staticClass: "icon-menu-open"
  })])]), _vm._v(" "), (_vm.sortedUsersFilteredWithTags.length < 1) ? _c('h4', {
    staticClass: "explainer-text"
  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale].no_users_matches) + "\n          ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedUsersFilteredWithTags), function(user) {
    return _c('li', {
      key: user.user_calendar_id,
      staticClass: "user-item",
      class: {
        'user-item--is-open': user.id === _vm.activeUserId
      },
      on: {
        "click": function($event) {
          return _vm.setActiveUserId(user.id)
        }
      }
    }, [(user.id !== _vm.activeUserId) ? _c('div', {
      staticClass: "user-item__name"
    }, [_c('span', {
      staticClass: "icon-arrow-right4"
    }), _vm._v(" "), (user.default_thumb_url) ? _c('img', {
      staticClass: "user-item__name__img",
      attrs: {
        "src": user.default_thumb_url
      }
    }) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(user.name))])]) : _vm._e(), _vm._v(" "), (user.id !== _vm.activeUserId) ? _c('div', [(_vm.userHasAgreements(user.id)) ? _c('span', {
      staticClass: "icon-file-text2"
    }) : _vm._e(), _vm._v("\n              " + _vm._s(_vm.getUserTeachingHoursDiff(user.id)) + "\n              "), _c('span', {
      staticClass: "icon-arrow-down4"
    })]) : _vm._e(), _vm._v(" "), (user.id === _vm.activeUserId) ? _c('SubjectsDistributionUser', {
      attrs: {
        "activeUserId": _vm.activeUserId,
        "isPoolsDeactivated": _vm.isPoolsDeactivated
      },
      on: {
        "editSubject": _vm.setEditSubject,
        "editTask": _vm.setEditTask,
        "close": _vm.resetActiveUserId
      }
    }) : _vm._e()], 1)
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "subjects-and-tasks"
  }, [(_vm.isTasksView) ? _c('SubjectsDistributionTasks') : _c('div', {
    staticClass: "doTable"
  }, [_c('div', {
    staticClass: "subject-dist__header"
  }, [_c('div', {
    staticClass: "subject-dist__header__left"
  }, [_c('DoFiltersFilter', {
    attrs: {
      "title": _vm.i18n[_vm.locale]['grades'],
      "tags": _vm.klassTags,
      "selectedTags": _vm.selectedKlassFilters
    },
    on: {
      "select": _vm.toggleKlassTag,
      "clear": _vm.clearSelectedKlassFilters
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": _vm.i18n[_vm.locale]['subjects_status'],
      "tags": _vm.subjectStatusFilters,
      "selectedTags": _vm.selectedSubjectStatusFilters
    },
    on: {
      "select": _vm.toggleSelectedSubjectStatusFilters,
      "clear": _vm.clearSelectedSubjectStatusFilters
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": _vm.i18n[_vm.locale]['subjects'],
      "tags": _vm.uniqueSubjects,
      "selectedTags": _vm.selectedSubjectFilters
    },
    on: {
      "select": _vm.toggleSelectedSubjectFilters,
      "clear": _vm.clearSelectedSubjectFilters
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "subject-dist__header__right"
  }, [(_vm.isUpdatingSchoolYear) ? _c('div', {
    staticClass: "do-spinner do-spinner--small"
  }) : _vm._e(), _vm._v(" "), (_vm.userCanManageSchool && _vm.isSchoolDanish) ? _c('DoButtonAndDate', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: false,
        placement: 'top'
      }),
      expression: "{\n                  arrow: false,\n                  placement : 'top'\n                }"
    }],
    attrs: {
      "content": "Fag kan ønskes af brugere med rettigheden",
      "selectedDate": _vm.subjectsRequestEndDate
    },
    on: {
      "dateChanged": _vm.onSetSubjectsRequestEndDate
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('ul', {
    staticClass: " doTable__items\n            "
  }, _vm._l((_vm.filteredKlassCals), function(klassCal, idx) {
    return _c('li', {
      key: klassCal.id,
      staticClass: "doTable__klass"
    }, [_c('div', {
      staticClass: "doTable__klass__header"
    }, [_c('div', [_vm._v(_vm._s(klassCal.name))]), _vm._v(" "), _c('div', {
      staticClass: "doTable__klass__header__flex"
    }, [(_vm.isSchoolDanish && idx === 0) ? _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          animateFill: false,
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window'
        }),
        expression: "{\n                         arrow: true,\n                         animateFill: false,\n                         animation : 'shift-away',\n                         zIndex: '999999992',\n                         boundary: 'window'}"
      }],
      staticClass: "icon__bg-circle",
      attrs: {
        "content": "Ændre fag der tæller i med i Timer i skoleåret"
      },
      on: {
        "click": function($event) {
          _vm.isModalKlassTotalHours = true
        }
      }
    }, [_c('span', {
      staticClass: "icon-wrench"
    })]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale].hours_in_school_year) + ":")]), _vm._v(" "), _c('span', {
      staticClass: "doTable__klass__header__hours"
    }, [_vm._v(_vm._s(klassCal.vTotalHours))])])]), _vm._v(" "), _c('ul', {
      staticClass: "subjects"
    }, _vm._l((klassCal.vSubjects), function(subject) {
      return _c('li', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            arrow: true,
            onShow: function () { return subject.vHasTeachers; }
          }),
          expression: "{\n                  arrow: true,\n                  onShow: () => subject.vHasTeachers\n                }"
        }],
        key: subject.id,
        staticClass: "subjects_subject",
        class: [{
          'subject--has-user': subject.vHasTeachers
        }, {
          'subject--has-room': subject.vHasRooms
        }, {
          'subject--has-request': subject.vRequestedBy.length > 0
        }],
        style: ({
          'background': subject.color
        }),
        attrs: {
          "content": subject.vUserNames
        },
        on: {
          "click": function($event) {
            return _vm.setEditSubject(subject)
          }
        }
      }, [_vm._v("\n                  " + _vm._s(subject.name) + " (" + _vm._s(subject.hours) + ")\n                ")])
    }), 0)])
  }), 0)])], 1)])], _vm._v(" "), (_vm.isSubjectModal) ? _c('SubjectForm', {
    attrs: {
      "showModal": _vm.isSubjectModal,
      "editSubject": _vm.editSubject,
      "propIsLoading": _vm.isSubjectLoading,
      "isShowSubjectsRequest": _vm.isShowSubjectsRequest,
      "subjectsRequestsInHash": _vm.subjectsRequestsInHash
    },
    on: {
      "deleteSubject": _vm.deleteSubject,
      "close": _vm.closeModal,
      "updateSubject": _vm.updateSubject
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "d-modal"
    }
  }, [(_vm.isConfirmDeletion) ? _c('ModalConfirmation', {
    attrs: {
      "showClose": false
    },
    on: {
      "close": function($event) {
        return _vm.$store.commit('setConfirmDeletion', false)
      },
      "confirm": _vm.confirmDelete
    }
  }, [_c('h3', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_vm._v(_vm._s(_vm.itemToDelete.name))])]) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "d-modal"
    }
  }, [(_vm.theEditTask) ? _c('DModal', {
    attrs: {
      "showClose": false
    }
  }, [_c('SubjectsDistributionTasksCreate', {
    attrs: {
      "slot": "insertComponent",
      "editTask": _vm.theEditTask
    },
    on: {
      "close": function($event) {
        _vm.theEditTask = null
      }
    },
    slot: "insertComponent"
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('StandardDurationSetting', {
    attrs: {
      "isForImportInZEN": true,
      "isOpenModal": _vm.isOpenDurationModal
    },
    on: {
      "close": function($event) {
        _vm.isOpenDurationModal = false
      },
      "submit": _vm.saveUpdatedDuration
    }
  }), _vm._v(" "), (_vm.isModalKlassTotalHours) ? _c('DModal', {
    attrs: {
      "isBgOverlay": true,
      "show-close": false
    }
  }, [_c('div', {
    staticClass: "d-modal text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h4', [_vm._v("Ændre \"Timer i skoleåret\"")]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle",
    on: {
      "click": function($event) {
        _vm.isModalKlassTotalHours = false
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('div', {
    staticClass: "label-with-toggle",
    on: {
      "click": _vm.toggleDoesRessCount
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Skal ressourcetimer tælle med i tallet \"Timer i skoleåret\" på denne side?")]), _vm._v(" "), _c('app-toggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.doesRessCountInKlassTotalHours
    }
  })], 1)])])]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9319a330!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubjectsDistribution/SubjectsDistribution.vue
// module id = 1702
// module chunks = 1